//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      active: 0,
    };
  },
  props: {
    data: {
      required: true,
    },
    title: {
      required: false,
      default: "FAQs",
    },
    removeContainerClass: {
      required: false,
      default: false,
    },
    expandAll: {
      required: false,
      default: false,
    },
    whiteBg: {
      required: false,
      default: false,
    },
    // Hindsight's name for each question's toggle, from the page that shows these FAQs; none by default.
    hsEl: {
      type: String,
      default: null,
    },
  },
  methods: {
    setActive(index) {
      if (index === this.active) this.active = null;
      else this.active = index;
    },
  },
};
